:host {
  display: block;
}

.sensor-data {
  padding: calc(var(--spacer) * 2);
  padding-left: 0;
}

.sensor-data-list {
  display: flex;
  align-items: stretch;
  flex-wrap: wrap;
  column-gap: calc(var(--spacer) * 2);

  gz-form-field {
    flex: 0 0 32%;
  }

  gz-label-field {
    flex: 0 0 100%;
  }

  &.one-input-raw {
    gz-form-field {
      flex: 0 0 98%;
    }
  }

  &.two-input-raw {
    gz-form-field {
      flex: 0 0 48%;
    }
  }
}

.sensor-wrapper {
  max-width: 900px;
}

.hidden {
  display: none !important;
}